import(/* webpackMode: "eager" */ "/var/www/boltfreight/node_modules/leaflet/dist/leaflet.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/boltfreight/src/components/GlobalFaviconSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/boltfreight/src/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/boltfreight/src/styles/tailwind.css");
